// extracted by mini-css-extract-plugin
module.exports = {"ProductHeader":"styles_ProductHeader__78XWc","details":"styles_details__zfRqv","images":"styles_images__p2f_X","tags":"styles_tags__yl1fR"};